
import { Outlet, useLocation } from 'react-router'

import { motion } from 'framer-motion';
import { useEffect, useLayoutEffect, useState } from 'react';
import Header from '../components/header/Header';
import Footer from '../components/home/Footer';

const PageContainer = () => {




    const location = useLocation();


    useEffect(() => {
      
      window.scrollTo(0, 0);
    }, [location.pathname]);
  
  

    const [headerToggle, setHeaderToggle] = useState(false)


    const pageVariants = {
      initial: { translateY: 10, opacity: 0 },
      in: { translateY: 0, opacity: 1 },
      out: { translateY: -10, opacity: 0 }
    };
  
    const pageTransition = {
      type: 'tween',
      ease: 'easeIn',
      duration: 1
    };
  return (
    <div>
    <Header/>
    <div className={`${headerToggle ? 'blur' : 'blur-0'} duration-300 `}>
     
      <motion.div
        key={location.pathname}
        initial='initial'
        animate='in'
        exit='out'
        variants={pageVariants}
        transition={pageTransition}

        className=' bg-white'>
          <div className='z-10 relative bg-white overflow-hidden'>
        <Outlet />
        </div>
        <Footer />
      </motion.div>

    </div>
    </div>
  )
}

export default PageContainer